<template>
  <div>
    <TopNavigationBar/>
  </div>
</template>

<style>
</style>

<script>
import TopNavigationBar from '../components/TopNavigationBar.vue';

export default {
  components: 
  {
    TopNavigationBar
  }
}
</script>